// Translations
import error from 'pages/error/translations/ar'
import login from 'pages/login/translations/ar'
import passwordChange from 'pages/password-change/translations/ar'
import register from 'pages/register/translations/ar'
import reset from 'pages/reset/translations/ar'
import termsOfService from 'pages/terms-of-service/translations/ar'
import twoFactorAuthentication from 'pages/two-factor-authentication/translations/ar'
import verification from 'pages/verification/translations/ar'

// Translation: Arabic > Pages
const pages = Object.freeze({
	error,
	login,
	passwordChange,
	register,
	reset,
	termsOfService,
	twoFactorAuthentication,
	verification
})

// Export
export default pages
